"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _onLoad = require("./onLoad");

var executeCallback = function executeCallback(callback) {
  try {
    callback(window.top.pageYOffset);
  } catch (err) {
    console.log('onScroll error', err);
  }
};

var callbacks = [];
/**
  * @callback onScrollCallback
  * @param {number} scrollTop
  */

/**
 * Registers a callback to be called when the page is scrolled
 * @param {onScrollCallback} callback
 * @example
 *
 * import { onScroll } from '@demant/wdh';
 *
 * onLoad((scrollTop) => {
 *   // Code executes when the page is scrolled. The amount scrolled is passed in the scrollTop parameter.
 * });
 */

var onScroll = function onScroll(callback) {
  callbacks.push(callback);
  executeCallback(callback);
};

var executeCallbacks = function executeCallbacks() {
  var callback;
  var i;
  var len;

  for (i = 0, len = callbacks.length; i < len; i += 1) {
    callback = callbacks[i];
    executeCallback(callback);
  }
};

if (typeof window !== 'undefined') {
  window.top.addEventListener('scroll', function () {
    executeCallbacks();
  });
}

(0, _onLoad.onLoad)(function () {
  setTimeout(function () {
    executeCallbacks();
  }, 0);
});
var _default = onScroll;
exports["default"] = _default;